import { Component } from 'react';
import { Button } from 'react-bootstrap';
import { TextSaveVo } from '../blogData/TextSaveVo';
interface MyProps { textSaveVo: TextSaveVo, callback: Function }
interface MyState { textSaveVo: TextSaveVo }
class DetailBox extends Component<MyProps, MyState>
{
    

        constructor(props: MyProps) {
            super(props);
            this.state = { textSaveVo: this.props.textSaveVo }
        }

        componentDidMount(): void {
           
            console.log("DetailBox componentDidMount", this.state.textSaveVo);
        }
        componentDidUpdate(prevProps: Readonly<MyProps>, prevState: Readonly<MyState>, snapshot?: any): void {
            if (this.props.textSaveVo !== prevProps.textSaveVo) {
                this.setState({ textSaveVo: this.props.textSaveVo });
                
            }
        }
    
    render() {
        let disabled: boolean = false;
        //text with 3 buttons
        let favCode: string = (this.state.textSaveVo.fav===1)?"unfav":"fav";
        let favText: string = (this.state.textSaveVo.fav===1)?"Remove from Favorites":"Add to Favorites";

        return (
            <div>
                <div className='shade' onClick={() => { this.props.callback() }} ></div>
            
        <div className="gen-screen">
             
            <textarea readOnly className="form-control gen-screen__text-area" id="exampleFormControlTextarea1" rows={3} defaultValue={this.state.textSaveVo.text.trim()} />
            <Button disabled={disabled} className="btn btn-success gen-screen__button" onClick={() => { this.props.callback("copy") }}>Copy</Button>
            <Button disabled={disabled} className="btn btn-primary gen-screen__button" onClick={() => { this.props.callback("download") }}>Download</Button>
            <Button className="btn btn-warning gen-screen__button" onClick={() => { this.props.callback(favCode) }}>{favText}</Button>
            <Button className="btn btn-danger gen-screen__button" onClick={() => { this.props.callback("delete") }}>Delete</Button>
            <Button variant='danger' className='close-button' onClick={() => { this.props.callback("close") }}>X</Button>
        </div>
        </div>
        )
    }
}
export default DetailBox;